import {DialogStore, growlStore, kpiWeighingDialogListStore, validationStore} from "../../../store";
import {observer} from "mobx-react";
import {WeighingCreateForm} from "./WeighingCreateForm";
import {kpiWeighingCreateStore} from "../../../store/kpi/KpiWeighingCreateStore";
import {dateFormat, toNumberString} from "../../../utils";
import {api, convertWeighingType} from "../../../api";
import {FieldInput} from "../../ui";
import {WeighingListItemDto} from "../../../api/kpi";
import {makeAutoObservable} from "mobx";
import {useEffect, useState} from "react";

export type WeighingDialogProps = {
    store: DialogStore
}

interface RowProps {
    val: WeighingListItemDto
    reload: () => Promise<any>
}

class RowStore {
    get loading(): boolean {
        return this._loading;
    }

    set loading(value: boolean) {
        this._loading = value;
    }
    get amount(): string {
        return this._amount;
    }

    set amount(value: string) {
        this._amount = value;
    }
    set original(value: WeighingListItemDto) {
        this._original = value;
    }
    get original(): WeighingListItemDto {
        return this._original;
    }

    get dirty(): boolean {
        return `${this.original.amount}` !== this.amount
    }

    private _original: WeighingListItemDto
    private _amount: string
    private _loading: boolean = false
    constructor(org: WeighingListItemDto) {
        this._original = org
        this._amount = org.amount === undefined ? '' : `${org.amount}`
        makeAutoObservable(this)
    }

    async save() {
        const {
            customerId,
            date,
            type,
        } = this.original
        await api.kpi.api.updateWeighing(this.original.id!, {
            amount: parseFloat(this.amount),
            customerId: customerId!,
            date: date!,
            type: type!
        })
        this.loading = false
    }
}

function renderCustomer(val: WeighingListItemDto) {
    const name = val.customer?.displayName || val.customer?.name || val.customerId
    if (val?.customer?.customerNumber) {
        return `${name} (${val?.customer?.customerNumber})`
    }
    return name
}

const Row = observer(function ({
                                   val,
    reload
                               }: RowProps) {
    const [store] = useState(new RowStore(val))
    useEffect(() => {
        store.original = val
    }, [val, store])
    return <tr>
        <td>{renderCustomer(val)}</td>
        <td>{dateFormat(val.date, true)}</td>
        <td>{convertWeighingType(val.type!)}</td>
        <td>
            <FieldInput
                small={true}
                value={`${store.amount}`}
                inputTransform={(v) => toNumberString(v)}
                onChange={v => {
                    store.amount = v
                }}
            />
        </td>
        <td>
            <button
                className={`button is-primary is-small is-rounded ${store.loading ? 'is-loading' : ''}`}
                disabled={!store.dirty || store.loading}
                onClick={async () => {
                    await store.save()
                    await reload()
                }}
            >Speichern</button>
        </td>
    </tr>
})

const WeighingDialog = observer(function WeighingDialog({
                                                            store
                                                        }: WeighingDialogProps) {
    return <>
        {store.dialogOpen && <div className={`modal is-active`}>
            <div className="modal-background" onClick={() => {
            }}></div>
            <div className="modal-content" style={{
                height: '90%',
                width: '90%'
            }}>
                <div className="modal-card" style={{
                    height: '100%',
                    width: '100%'
                }}>
                    <header className="modal-card-head">
                        <div className="modal-card-title">
                            Posterfassung
                        </div>
                        {
                            <button className="delete" aria-label="close" onClick={() => {
                                store.dialogOpen = false
                            }}></button>}
                    </header>
                    <section className="modal-card-body" style={{
                        display: 'flex',
                        flexDirection: 'column',
                        overflow: 'hidden'
                    }}>
                        <WeighingCreateForm
                            valid={kpiWeighingCreateStore.valid}
                            data={kpiWeighingCreateStore.formData}
                            disabled={kpiWeighingCreateStore.creating}
                            onChange={data => {
                                kpiWeighingCreateStore.formData = data
                                kpiWeighingDialogListStore.setCustomerId(data.customer?.id)
                            }}
                            validate={async () => await kpiWeighingCreateStore.validate()}
                            create={async () => {
                                const success = await kpiWeighingCreateStore.create()
                                if (success) {
                                    growlStore.add({
                                        closable: true,
                                        autoclose: true,
                                        message: 'Posterfassung erfolgreich'
                                    })
                                    store.dialogOpen = false
                                }
                            }}
                            help={{
                                amount: validationStore.getFor('amount'),
                                date: validationStore.getFor('date'),
                                type: validationStore.getFor('type'),
                                customerId: validationStore.getFor('customerId')
                            }}
                        />
                        <div style={{
                            flex: 1,
                            overflow: 'inherit',
                            paddingTop: '2em',
                            borderTop: '1px solid var(--bulma-border)',
                            marginTop: '2em'
                        }}>
                            <div className="cmp-scroll-table" style={{height: '100%', overflow: 'hidden'}}>
                                <div className="scroller" style={{height: '100%', overflowY: 'auto'}}>
                                    <table className="table is-fullwidth is-hoverable is-striped">
                                        <thead>
                                        <tr>
                                            <th>Kunde</th>
                                            <th style={{width: '10em'}}>Datum</th>
                                            <th>Typ</th>
                                            <th>Gewicht (kg)</th>
                                            <th style={{width: '7em'}}></th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {kpiWeighingDialogListStore.items.length > 0 ? (
                                            kpiWeighingDialogListStore.items.map((val, index) =>
                                                <Row
                                                    val={val} key={val.id}
                                                    reload={async () => {
                                                        await kpiWeighingDialogListStore.load()
                                                    }}
                                                />)
                                        ) : (
                                            <tr>
                                                <td colSpan={4} style={{textAlign: 'center'}}>Keine Daten vorhanden</td>
                                            </tr>
                                        )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </section>
                    <footer className="modal-card-foot">
                    </footer>
                </div>
            </div>
        </div>}
    </>
})

export {
    WeighingDialog
}
